var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MessageDialog } from "../components/messageDialog";
import * as DeleteConfirmDialog from "../components/deletePhoneConfirmDialog";
import axios from "axios";
var _components = {};
$(function () {
    _components.updatePhoneButton = $('#sendLoginButton').on('click', updatePhone_onClick);
    _components.passwordInput = $("#passwordInput").keyup(checkPasswordStrength);
    _components.messageDialog = new MessageDialog();
});
function updatePhone_onClick(e) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var login, password, checkPwdRes, err_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    login = $("#loginInput").val();
                    password = $("#passwordInput").val();
                    checkPwdRes = checkPasswordStrength(password);
                    if (!checkPwdRes) {
                        DeleteConfirmDialog.show("Ошибка", "Введите надежный пароль");
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, axios.post('api/user/update', {
                            Login: login,
                            Password: password
                        })
                            .then(function () {
                            location.reload();
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    return [4 /*yield*/, DeleteConfirmDialog.show("Ошибка", ((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.data) || err_1.message)
                            .then(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                DeleteConfirmDialog.close();
                                return [2 /*return*/];
                            });
                        }); })
                            .catch(function (e) {
                            DeleteConfirmDialog.close();
                        })];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function updatePhoneInfo(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('api/user/update', data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function checkPasswordStrength() {
    var password_strength = $("#passCheckBar");
    var password = $("#passwordInput").val();
    //if textBox is empty
    if (password.length === 0) {
        password_strength.html("");
        return;
    }
    //Regular Expressions
    var regex = [];
    regex.push("[A-Z]"); //For Uppercase Alphabet
    regex.push("[a-z]"); //For Lowercase Alphabet
    regex.push("[0-9]"); //For Numeric Digits
    regex.push("[$@$!%*#?&]"); //For Special Characters
    var passed = 0;
    //Validation for each Regular Expression
    for (var i = 0; i < regex.length; i++) {
        if ((new RegExp(regex[i])).test(password)) {
            passed++;
        }
    }
    //Validation for Length of Password
    if (passed > 2 && password.length > 8) {
        passed++;
    }
    //Display of Status
    var color = "";
    var passwordStrength = "";
    switch (passed) {
        case 0:
            break;
        case 1:
            passwordStrength = "не надежен";
            color = "Red";
            break;
        case 2:
            passwordStrength = "средний";
            color = "darkorange";
            break;
        case 3:
            break;
        case 4:
            passwordStrength = "надежный";
            color = "Green";
            break;
        case 5:
            passwordStrength = "очень надежный";
            color = "darkgreen";
            break;
    }
    password_strength.html(passwordStrength);
    password_strength.css("color", color);
    if (passed > 3)
        return true;
    return false;
}
